<template>
  <div class="classroom-list">
    <el-table
      ref="multipleTable"
      :data="classroomList"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      class="common-edit-button"
    >
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column type="selection" width="55px"> </el-table-column>
      <el-table-column prop="classroomCode" width="110px" label="课室编号">
      </el-table-column>
      <!-- width="250px" -->
      <el-table-column
        prop="classroomName"
        :show-overflow-tooltip="true"
        label="课室名称"
      >
      </el-table-column>
      <!-- <el-table-column prop="beaconCode" label="信标">
        <template slot-scope="scope">
          <el-tag
            :key="index"
            v-for="(beaconCode, index) in scope.row.beaconCodeList"
          >
            {{ beaconCode }}
          </el-tag>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="185px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 修改 -->
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click="editClick(scope.row)"
              v-hasPermi="'sc:classroom:edit'"
              size="small"
            >修改
            </el-button>
            <!-- 删除 -->
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="deleteClick(scope.row)"
              v-hasPermi="'sc:classroom:delete'"
              size="small"
            >删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <classroomEdit
      :dialogVisible.sync="editShow"
      :classroomInfo="classroomInfo"
      v-show="editShow"
    />
  </div>
</template>

<script>
import classroomEdit from "../classroom-edit/classroom-edit.vue";

export default {
  name: "",
  props: {
    classroomList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  inject: ["refresh"],
  data() {
    return {
      classroomInfo: {},
      editShow: false,
      selectList: [],
    };
  },
  components: {
    classroomEdit,
  },
  methods: {
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
    },
    editClick(item) {
      // console.log(item);
      this.classroomInfo = item;
      this.editShow = true;
    },
    deleteClick(item) {
      this.$confirm("删除课室可能会影响到已编辑的课程表，是否确定删除课室?", "删除课室", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // console.log("item=>", item);
          // console.log('调用接口，成功后刷新 this.refresh()')
          let list = [];
          list.push(item.id);
          // console.log(list);
          // deleteBeacon
          this.delete(this.$url.deleteClassroom, list)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./classroom-list.scss";
</style>
